var properties = {
    VAULT_ID: process.env.VAULT_ID || "",
    VAULT_URL: process.env.VAULT_URL || "",
    AWS_GATEWAY_URL: process.env.AWS_GATEWAY_URL || "",
};
export default properties;
